(ns frontend.view.data-import.steps.intro
  (:require [common.localization :as loc]
            [frontend.view.data-import.db :as db]
            [frontend.view.data-import.events :as events]
            [frontend.bootstrap.components :as rbs]
            [frontend.utils :as fu]
            [ui.components.button.view :as button]))

(defn option [state label key]
  (let [checked? (db/get-template-option state key)]
    [:label
     {:class-name "zap-inlined-checkbox-label"}
     [:input {:class-name "zap-inlined-checkbox__green"
              :checked    (boolean checked?)
              :on-change  (fn [e]
                            (db/set-template-option state key (not checked?)))
              :type       "checkbox"}]
     [:span
      {:class-name "checkmark"}]
     label]))

(defn numbered-text
  ([number text]
   (numbered-text number text nil))
  ([number text cls]
   [:div
    [:p
     {:class "flex gap-3 font-semibold"}
     [:span
      {:class "inline-flex items-center justify-center rounded-full border border-primary-regular-border min-w-6 h-6 px-2 text-xs leading-none"}
      [:span number]]
     [:span
      text]]]))

(defn view [state]
  (let [step (:import-step @db/import-state)]
    [:div
     {:class "px-4 py-6 mx-auto max-w-5xl"}
    [:div
     (when (:downloading @db/import-state)
       [:div
        {:class "flex flex-col justify-center gap-4"}
         [:i.spinner]
         [:p {:class-name "text-lg text-center mb-5"}
          (loc/tr :import-downloading-text)]])
     [:div

      [:p
       {:class "flex flex-col gap-3"}
       [:span
        {:class "block text-xl font-bold"}
        (loc/tr :import-info-heading-part-1)
        [:strong (loc/tr :import-info-heading-part-strong)]]

      [:span
        (loc/tr :import-info-heading-part-2)
       [:a {:href   (loc/tr :mailto [(loc/tr :support-email-address)])}
        (loc/tr :support-email-address)]
       (loc/tr :import-info-heading-part-3)]]]
     [:div
      {:class "py-8 flex flex-col gap-4"}
      [:div
       {:class "flex gap-3"}
       [:span
        {:class "font-bold"}
        (loc/tr :import-steps-info)
        #_[:a
           {:href     "#"
            :on-click (fn [e]
                        (.preventDefault e)
                        (.stopPropagation e))}
           (loc/tr :import-what-is-this)
           ]]]
      [:div
       {:class "p-3 flex flex-col gap-4"}
       (numbered-text 1 (loc/tr :import-step-1-heading))
       (numbered-text 2 (loc/tr :import-step-2-heading))
       (numbered-text 3 (loc/tr :import-step-3-heading) "last-row")]
       [:div
        {:class-name "flex gap-3"}
        [button/sm-secondary-hollow
         {:on-click   (fn [_]
                        (swap! db/import-state assoc :downloading true)
                        (events/download-template state (fn []
                                                          (js/setTimeout
                                                            #(swap! db/import-state dissoc :downloading) 1000))))}
         (loc/tr :import-transfer-download-button)]
        [:label
         {:class-name "px-3 py-2 m-0
                       text-sm text-primary-regular-text hover:text-primary-gloomy-text disabled:text-disabled-regular-text
                       outline-none rounded border border-solid border-primary-regular-border hover:border-primary-gloomy-border disabled:border-disabled-regular-border
                       leading-5 font-muli font-semibold text-md whitespace-nowrap flex gap-2 justify-center items-center
                       bg-primary-regular hover:bg-primary-gloomy disabled:bg-disabled-regular focus:scale-[0.97] cursor-pointer"}
         [:input
          {:type       "file"
           :accept     ".xlsx, .xls"
           :hidden     "hidden"
           :on-change  (fn [e]
                         (events/import-file-chosen e state))
           :class-name "hide"}]
         (loc/tr :import-transfer-upload-button)]]

       (when-let [url (:download-url @state)]
         [:p
          {:class-name "text-sm mb-2"}
         (loc/tr :import-download-text)
          [:a.text-success {:href   url
               :target "_blank"}
           (loc/tr :import-download-link)]])
       [:p
        {:class-name "text-base-light-text-paler text-xs"}
        [:strong
         (loc/tr :import-intro-footer-note)]

        [:span
         (loc/tr :import-intro-footer-text)]]]]]))
